import { useNavigate } from "react-router-dom";
import "../../../styles/fontSizes.scss";
import "./crums.scss";

//Necesita que el padre tenga positicionamiento relativo.
//Recibe el tipo de órbita, limitado a la implementación del estilo del componente dentro de su hoja de estilo
const Crums = ({ text, link, className }) => {
  const navigateTo = useNavigate();
  return (
    <>
      <a
        href={""}
        className={className + " crums__anchor"}
        onClick={() => navigateTo(link)}
      >
        {text}
      </a>
    </>
  );
};

export default Crums;
